import React, { useEffect, useRef, useState } from "react";
import {
  CustomAddress,
  CustomAutocomplete,
  CustomCheckbox,
  CustomDatePicker,
  CustomDropdown,
  CustomFileInput,
  CustomNumberInput,
  CustomTextarea,
  CustomTextInput,
} from "../../atoms";
import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import { Delete, Edit, Save } from "@mui/icons-material";
import CustomESign from "components/atoms/CustomESign";
import CustomTime from "../../atoms/CustomTime";
import CustomizeChip from "components/atoms/CustomizeChip";
import { useNavigate } from "react-router-dom";
import { generateURL } from "../services";
import { cloneDeep, isObject } from "lodash";
import moment from "moment";
import { getItem, showToast } from "services/utils";
import { Constants } from "services/keyConstants";
// import CustomDynamic from "../NestedTable/CustomDynamic";
import CustomDynamic from "./CustomDynamicForTable";

const RowCell = (props) => {
  const {
    row,
    column,
    renders,
    rowIndex,
    columnIndex,
    config,
    helperFunction,
    errorRef,
    isLock = false,
    isDisable: haveDisable,
  } = props;
  let { error, msg: errorMsg } = errorRef?.current?.[rowIndex]?.[
    column?.uniqueName
  ] ?? { error: false, msg: "" };

  const [renderRow, renderCells] = renders;
  const {
    handleBtnClick,
    helperUtils,
    changeRowDataOnDependencyFields,
    isISODateString,
    removeMatchingItems,
    hasEmptyValue,
  } = helperFunction;
  const navigate = useNavigate();
  const [_, forceUpdate] = useState({});
  const [esignOpen, setEsignOpen] = useState(false);
  const value = row?.[column?.uniqueName] ?? "";
  const render = () => forceUpdate({});
  column.uniqueName ? (renderCells[column.uniqueName] = render) : null;

  const passCurrentData = {
    row,
    rowIndex,
    column,
    columnIndex,
  };

  const {
    columns,
    rows,
    isViewMode,
    renderOptions,
    reRenders,
    onSubmit,
    onESign,
    onDelete,
    multipleESign,
    dependencyFields,
    chip,
    navLink,
    dynamicOptionsByRows = false,
    rowByOptions,
    modifyData = false,
    optionsUniqueness,
    rendersRows,
    dynamicActions = false,
    dynamicType = false,
    dynamicTypeRef = false,
    dynamicReadable = false,
    dynamicReadableRef = false,
    checkEsignById = false,
    userData,
    selectedRole,
    trackChanges = false,
    dataModify,
    dynamicViewMode = false,
    isImageinLink = false,
  } = config;

  const isDisable =
    haveDisable || !!dynamicReadableRef?.[rowIndex]?.[column?.uniqueName];

  if ((isLock || isDisable) && error) {
    errorRef.current[rowIndex][column?.uniqueName].error = false;
    errorRef.current[rowIndex][column?.uniqueName].msg = "";
    error = false;
    errorMsg = "";
  }

  const getValueByPath = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc?.[part], obj);
  };

  const getEnableDisableEsign = () => {
    if (!checkEsignById) return false;

    const userMatch =
      checkEsignById.checkWithuserId &&
      getValueByPath(row, checkEsignById.checkWithuserId) === userData?._id;

    const roleMatch =
      checkEsignById.checkWithDesignationId &&
      getValueByPath(row, checkEsignById.checkWithDesignationId) ===
        selectedRole?.roleId;

    if (
      checkEsignById.checkWithuserId &&
      checkEsignById.checkWithDesignationId
    ) {
      return !(userMatch && roleMatch); // both must match
    }

    if (checkEsignById.checkWithuserId) return !userMatch;
    if (checkEsignById.checkWithDesignationId) return !roleMatch;

    return false;
  };

  const myRowByOptions =
    ["dropdown", "dynamicDropdown"]?.includes(column?.type) &&
    Object.hasOwn(column, "uniqueOptions")
      ? optionsUniqueness?.availableOptions?.[column?.uniqueName] ?? []
      : rowByOptions?.[rowIndex]?.[column?.uniqueName] ?? [];

  const commonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const isHaveDynamicType = !!dynamicTypeRef?.[rowIndex]?.[column?.uniqueName]
    ? dynamicTypeRef?.[rowIndex]?.[column?.uniqueName]
    : false;

  const handleChange = (newValue, changeMethod = "", atFirstTime = false) => {
    row[column.uniqueName] = newValue;

    // if (!atFirstTime && !dataModify) {
    //   dataModify = true
    // }

    if (column?.uniqueName && !atFirstTime) {
      if (!trackChanges[rowIndex]) {
        trackChanges[rowIndex] = {};
      }
      trackChanges[rowIndex][column.uniqueName] = newValue;
    }
    delete errorRef?.current?.[rowIndex]?.[column?.uniqueName];
    if (renderOptions !== false) {
      const { specific, type } = renderOptions;
      if (specific === "all") {
        reRenders?.allRows();
      } else if (specific === "rows") {
        if (type === "single") {
          renderRow();
        }
      }
    }
    if (
      ["dropdown", "dynamicDropdown"].includes(column?.type) &&
      Object.hasOwn(column, "uniqueOptions")
    ) {
      if (newValue) {
        optionsUniqueness.availableOptions[column?.uniqueName] =
          removeMatchingItems(
            optionsUniqueness.availableOptions?.[column?.uniqueName],
            newValue
          );
        if (!(value === "") && !(Array.isArray(value) && value.length === 0)) {
          optionsUniqueness?.availableOptions?.[column?.uniqueName]?.push(
            value
          );
        }
      } else {
        optionsUniqueness.availableOptions[column?.uniqueName].push(
          optionsUniqueness.rowsOptions[rowIndex][column.uniqueName]
        );
      }
      optionsUniqueness.rowsOptions[rowIndex][column.uniqueName] = newValue;
      rendersRows.rows.forEach(([_, cells]) => {
        cells?.[column?.uniqueName]();
      });
    }
    if (dependencyFields !== false && !atFirstTime) {
      if (Object.keys(dependencyFields)?.includes(column?.uniqueName)) {
        if (dependencyFields?.[column?.uniqueName]?.type === "row") {
          const { handler } = dependencyFields?.[column?.uniqueName];
          const newValuesObj = handler(cloneDeep(passCurrentData));
          Object.keys(newValuesObj)?.forEach((changableUniqueName) => {
            row[changableUniqueName] = "";
            Object.hasOwn(row, changableUniqueName) !== false
              ? (row[changableUniqueName] = newValuesObj[changableUniqueName])
              : null;
            renderCells?.[changableUniqueName]
              ? renderCells[changableUniqueName]()
              : null;
          });
        } else if (dependencyFields?.[column?.uniqueName]?.type === "all") {
          changeRowDataOnDependencyFields(row, rowIndex, column, columnIndex);
        }
      }
    }
    if (
      dynamicOptionsByRows !== false &&
      Object.keys(dynamicOptionsByRows).includes(column?.uniqueName)
    ) {
      const { handler = () => {}, type = "row" } =
        dynamicOptionsByRows?.[column?.uniqueName];
      if (type === "row") {
        const newOptions = handler(cloneDeep(passCurrentData)) ?? {};
        Object.keys(newOptions).forEach((col) => {
          if (!rowByOptions[rowIndex]) {
            rowByOptions[rowIndex] = {};
          }
          rowByOptions[rowIndex][col] = newOptions[col];
          renderCells[col]();
        });
      }
    }
    if (
      modifyData !== false &&
      Object.keys(modifyData).includes(column?.uniqueName)
    ) {
      const { type = "row", handler = () => {} } =
        modifyData?.[column?.uniqueName];
      if (type === "row") {
        const render = handler(passCurrentData, { rows, columns });
        if (render) {
          renderRow();
        }
      }
    }

    if (dynamicType !== false) {
      const dynamicTypesKeys = Object.keys(dynamicType);
      if (dynamicTypesKeys?.includes(column?.uniqueName)) {
        let newDynamicType = {};
        if (typeof dynamicType?.[column?.uniqueName]?.handler === "function") {
          const { type = "row", handler = () => {} } =
            dynamicType?.[column?.uniqueName];
          if (type === "row") {
            newDynamicType = handler(cloneDeep(passCurrentData));
          }
        } else {
          newDynamicType = dynamicType?.[column?.uniqueName](
            cloneDeep(passCurrentData)
          );
        }
        // Object.keys(newDynamicType).forEach((key) => {
        //   dynamicTypeRef[rowIndex][key] = newDynamicType[key];
        //   renderCells[key] && renderCells[key]();
        // });
        Object.keys(newDynamicType).forEach((key) => {
          if (!dynamicTypeRef[rowIndex]) {
            dynamicTypeRef[rowIndex] = {}; // initialize
          }
          dynamicTypeRef[rowIndex][key] = newDynamicType[key];

          if (renderCells[key]) {
            renderCells[key]();
          }
        });
      }
    }

    if (dynamicReadable !== false) {
      const dynamicReadableKeys = Object.keys(dynamicReadable);
      if (dynamicReadableKeys.includes(column?.uniqueName)) {
        let newDynamicReadable = {};
        if (
          typeof dynamicReadable?.[column?.uniqueName]?.handler === "function"
        ) {
          const { type = "row", handler = () => {} } =
            dynamicReadable?.[column?.uniqueName];
          if (type === "row") {
            newDynamicReadable = handler(
              cloneDeep({
                ...passCurrentData,
                ...(!!changeMethod ? { changeMethod } : {}),
              })
            );
          } else {
            newDynamicReadable = newDynamicReadable?.[column?.uniqueName](
              cloneDeep({
                ...passCurrentData,
                ...(!!changeMethod ? { changeMethod } : {}),
              })
            );
          }
        }

        // Object.keys(newDynamicReadable).forEach((key) => {
        //   dynamicReadableRef[rowIndex][key] = newDynamicReadable[key];
        //   renderCells[key]();
        // });
        Object.keys(newDynamicReadable).forEach((key) => {
          if (!dynamicReadableRef[rowIndex]) {
            dynamicReadableRef[rowIndex] = {}; // make sure it's not undefined
          }

          dynamicReadableRef[rowIndex][key] = newDynamicReadable[key];

          if (renderCells[key]) {
            renderCells[key]();
          }
        });
      }
    }

    render();
  };

  useEffect(() => {
    handleChange(value, null, true);
  }, []);

  const handleDelete = () => {
    columns?.forEach((col) => {
      if (
        ["dropdown", "dynamicDropdown"].includes(col?.type) &&
        !!col?.uniqueOptions &&
        Object.keys(optionsUniqueness?.availableOptions)?.length > 0
      ) {
        row?.[col?.uniqueName] !== "" && !!row?.[col?.uniqueName]
          ? optionsUniqueness.availableOptions[col?.uniqueName].push(
              row?.[col?.uniqueName]
            )
          : null;
      }
    });
    handleBtnClick("delete", row, rowIndex, column, columnIndex);
  };

  if (column?.uniqueName === "srNo") {
    const isSaveActive =
      typeof onSubmit?.isActive === "boolean"
        ? onSubmit?.isActive
        : typeof onSubmit?.isActive === "function"
        ? onSubmit?.isActive(passCurrentData)
        : true;

    const isSaveVisible =
      typeof onSubmit?.isVisible === "boolean"
        ? onSubmit?.isVisible
        : typeof onSubmit?.isVisible === "function"
        ? onSubmit?.isVisible(passCurrentData)
        : true;

    const isDeleteActive =
      typeof onDelete?.isActive === "boolean"
        ? onDelete?.isActive
        : typeof onDelete?.isActive === "function"
        ? onDelete?.isActive(passCurrentData)
        : true;

    const isDeleteVisible =
      typeof onDelete?.isVisible === "boolean"
        ? onDelete?.isVisible
        : typeof onDelete?.isVisible === "function"
        ? onDelete?.isVisible(passCurrentData)
        : true;

    return (
      <Box
        sx={{
          ...commonStyle,
          width: "100%",
          gap: "8px",
        }}
      >
        {/* <Typography>{row?.srNo ? row?.srNo : Number(rowIndex) + 1}</Typography> */}
        <Typography>{Number(rowIndex) + 1}</Typography>
        {!isViewMode && !isLock && !row?.submitted ? (
          <>
            {onDelete !== false && isDeleteVisible ? (
              <Tooltip title={"Delete row"} arrow>
                <IconButton
                  color="error"
                  onClick={handleDelete}
                  disabled={rows?.length === 1 || !isDeleteActive}
                >
                  <Delete />
                </IconButton>
              </Tooltip>
            ) : null}
            {onSubmit?.type === "row" && isSaveVisible ? (
              <Tooltip title={"Submit row"} arrow>
                <IconButton
                  color="success"
                  onClick={() => {
                    handleBtnClick(
                      "submit",
                      row,
                      rowIndex,
                      column,
                      columnIndex
                    );
                  }}
                  disabled={!isSaveActive}
                >
                  <Save />
                </IconButton>
              </Tooltip>
            ) : null}
          </>
        ) : null}
      </Box>
    );
  } else if ((!value || value === "") && (column?.isReadOnly || isViewMode)) {
    return <Typography> - </Typography>;
  } else if (
    isViewMode ||
    isLock ||
    (isDisable && value !== "" && value?.length !== 0) ||
    row?.submitted ||
    !!column?.isReadOnly
  ) {
    let cellValue = null;
    if (
      Array.isArray(row?.[column?.uniqueName]) &&
      !["dynamic"].includes(column?.type)
    ) {
      if (column?.type === "file") {
        return (
          <Box
            sx={{
              ...commonStyle,
            }}
          >
            <CustomFileInput
              label={column.name}
              name={column.uniqueName}
              value={value}
              multiple={column?.multiple}
              error={error}
              helperText={errorMsg}
              isLock={isLock}
              isImageinLink={row?.submitted}
            />
          </Box>
        );
      }

      cellValue = column?.renderOptionValue
        ? row?.[column?.uniqueName]
            ?.map((o) => o?.[column?.renderOptionValue])
            ?.join(", ")
        : row?.[column?.uniqueName]?.length !== 0
        ? row?.[column?.uniqueName]?.join(", ")
        : null;
    } else if (column?.type === "esign") {
      const { time = false, userData = {} } = value;
      const constFormate = getItem(Constants?.DATE_FORMATE);

      cellValue = (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              py: "6px",
              display: "flex",
              flexDirection: "column",
              // alignItems: 'flex-start'
              alignItems: "center",
            }}
          >
            <Typography variant="h6" color="text.primary">
              {userData?.name ?? "N/A"}
            </Typography>
            <Typography variant="h6" color="text.primary">
              {userData?.designation ?? "N/A"}
            </Typography>
            <Typography variant="h6" color="text.primary">
              {isISODateString(time)
                ? moment(time).format(
                    !!constFormate ? constFormate : "DD/MM/YYYY hh:mm A"
                  )
                : time ?? "N/A"}
            </Typography>
          </Box>
        </Box>
      );
    } else if (column?.type === "date") {
      const constTimeFormate = getItem("timeFormats");
      const constFormate = getItem(Constants?.DATE_FORMATE);
      cellValue = isISODateString(value)
        ? moment(value).format(!!constFormate ? constFormate : "DD/MM/YYYY")
        : value;
    } else if (column?.type === "datetime") {
      const constFormate = getItem(Constants?.DATE_FORMATE);

      if (isISODateString(value)) {
        const datePart = moment(value).format(constFormate || "DD/MM/YYYY");
        const timePart = moment(value).format("hh:mm A");
        cellValue = (
          <div>
            <div>{datePart}</div>
            <div>{timePart}</div>
          </div>
        );
      } else {
        cellValue = value ?? "N/A";
      }
    } else if (column?.type === "dynamicDropdown") {
      cellValue =
        typeof value === "string"
          ? value
          : Array.isArray(value)
          ? value.join(", ")
          : value?.[column?.renderOptionValue];
    } else if (column?.type === "address") {
      cellValue = value?.finalAddress
        ? value.finalAddress
        : value
        ? value
        : "N/A";
    } else if (column?.type === "dropdown") {
      const isInvalid =
        column?.inValidValues &&
        ((Array.isArray(value) &&
          value.some((v) => column.inValidValues.includes(v))) ||
          (!Array.isArray(value) && column.inValidValues.includes(value)));

      const displayValue =
        typeof value === "string"
          ? value
          : Array.isArray(value)
          ? value.join(", ")
          : value?.[column?.renderOptionValue];

      cellValue = (
        <Box
          component="span"
          sx={{
            color: isInvalid ? "error.main" : "inherit",
            fontWeight: isInvalid ? 600 : 400,
          }}
        >
          {displayValue || "-"}
        </Box>
      );
    }

    // else if (column?.type === "dropdown") {
    //   cellValue =
    //     typeof value === "string"
    //       ? value
    //       : Array.isArray(value)
    //       ? value.join(", ")
    //       : value?.[column?.renderOptionValue];
    // }
    else if (column?.type === "dynamic") {
      const isActionsVisible = !!dynamicActions?.[column?.uniqueName]
        ? dynamicActions?.[column?.uniqueName]?.isVisible ?? true
        : true;

      const dynamicElements = !!isHaveDynamicType
        ? isHaveDynamicType
        : column?.elements;

      const isHaveMultiple = column?.multipleValues ?? false;

      let finalData;

      dynamicViewMode &&
        Object.keys(dynamicViewMode)?.forEach((key) => {
          if (key === column?.uniqueName) {
            const { type = "row", handler = () => {} } =
              dynamicViewMode?.[key] ?? {};
            if (type == "row") {
              finalData = handler(
                cloneDeep(passCurrentData),
                cloneDeep({
                  data: row[column?.uniqueName],
                  elements: dynamicElements,
                  isHaveMultiple,
                })
              );
            }
          }
        });
      return finalData;
    } else if (column?.type === "checkbox") {
      cellValue = (
        <CustomCheckbox
          label={`Enter ${column?.name}`}
          name={column.uniqueName}
          checked={!!value}
          onChange={() => {}}
          isReadOnly={true}
          isLock={true}
          error={error}
          helperText={errorMsg}
        />
      );
    } else if (column?.type === "file") {
      return (
        <Box
          sx={{
            ...commonStyle,
          }}
        >
          <CustomFileInput
            label={column.name}
            name={column.uniqueName}
            value={value}
            onChange={(e) => {
              handleChange(e?.target?.value);
            }}
            multiple={column?.multiple}
            error={error}
            helperText={errorMsg}
            isLock={isLock}
            isReadOnly={true}
          />
        </Box>
      );
    } else {
      const actionsConfig = dynamicActions?.[column?.uniqueName];
      const isActionsVisible =
        typeof actionsConfig?.isVisible === "function"
          ? actionsConfig.isVisible(row)
          : actionsConfig?.isVisible ?? true;

      const cellValue = Array.isArray(value) ? value.join(", ") : value;

      return (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            ...commonStyle,
          }}
        >
          <Typography variant="body1" sx={{ flex: 1 }}>
            {cellValue || "-"}
          </Typography>

          {isActionsVisible &&
            actionsConfig?.actions?.map((action, index) => {
              const show =
                typeof action?.isVisible === "function"
                  ? action.isVisible(row)
                  : action?.isVisible ?? true;

              const isActive =
                typeof action?.isActive === "function"
                  ? action.isActive(row)
                  : action?.isActive ?? true;

              return show ? (
                <IconButton
                  key={index}
                  color={action?.color ?? "default"}
                  disabled={!isActive}
                  title={action?.tooltip}
                  onClick={() =>
                    action?.handler?.(row, {
                      value,
                      index,
                      action,
                    })
                  }
                >
                  {action?.icon ?? <Edit />}
                </IconButton>
              ) : null;
            })}
        </Box>
      );
    }

    return <Typography>{cellValue === null ? "N/A" : cellValue}</Typography>;
  } else if (column?.type === "dynamic") {
    const isActionsVisible = !!dynamicActions?.[column?.uniqueName]
      ? dynamicActions?.[column?.uniqueName]?.isVisible ?? true
      : true;

    const dynamicElement = !!isHaveDynamicType
      ? isHaveDynamicType
      : column?.elements;

    const isHaveMultiple = column?.multipleValues ?? false;

    if (isHaveMultiple) {
      if (!value) {
        row[column.uniqueName] = [];
      } else if (Array.isArray(value) && value.length === 0) {
        row[column.uniqueName].push({});
      }
    } else {
      if (value && typeof value === "object") {
        const hasKeys = Object.keys(value).length > 0;
        if (!hasKeys) {
          row[column.uniqueName] = {};
        }
      } else if (!value) {
        row[column.uniqueName] = {};
      }
    }

    return (
      <Box>
        {Array.isArray(value) ? (
          value?.map((element, elementIndex) => (
            <Box
              sx={{
                display: "flex",
                gap: "15px",
                alignItems: "center",
                justifyContent: "space-around",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  overflowX: "auto",
                  gap: "10px",
                  paddingY: "10px",
                  scrollbarWidth: "thin",
                  scrollbarColor: "#0000FF #00000000",
                }}
              >
                {isActionsVisible
                  ? dynamicActions?.[column?.uniqueName]?.actions?.map(
                      (action) =>
                        !!action?.isVisible ? (
                          <IconButton
                            color={action?.color ?? "default"}
                            disabled={!action?.isActive ?? false}
                            onClick={() => {
                              action?.handler(passCurrentData, {
                                value: element,
                                index: elementIndex,
                                action,
                              });
                            }}
                          >
                            {action?.icon ?? <Edit />}
                          </IconButton>
                        ) : null
                    )
                  : null}
                <CustomDynamic
                  element={element}
                  elements={dynamicElement}
                  elementIndex={elementIndex}
                  path={[column?.uniqueName]}
                  cellRef={row?.[column?.uniqueName]}
                  currentData={passCurrentData}
                  parantRender={() => {
                    handleChange(row?.[column?.uniqueName]);
                  }}
                  sx={{
                    minWidth: "200px",
                  }}
                />
              </Box>
            </Box>
          ))
        ) : (
          <Box
            sx={{
              display: "flex",
              overflowX: "auto",
              padding: "10px",
              scrollbarWidth: "thin",
              scrollbarColor: "#0000FF #00000000",
              gap: "20px",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            {isActionsVisible
              ? dynamicActions?.[column?.uniqueName]?.actions?.map((action) =>
                  !!action?.isVisible ? (
                    <IconButton
                      color={action?.color ?? "default"}
                      disabled={!action?.isActive ?? false}
                      onClick={() => {
                        action?.handler(passCurrentData, {
                          value: element,
                          index: elementIndex,
                          action,
                        });
                      }}
                    >
                      {action?.icon ?? <Edit />}
                    </IconButton>
                  ) : null
                )
              : null}
            {dynamicElement?.map((element, elementIndex) => {
              return (
                <CustomDynamic
                  element={element}
                  elements={dynamicElement}
                  elementIndex={elementIndex}
                  path={[column?.uniqueName]}
                  cellRef={row?.[column?.uniqueName]}
                  currentData={passCurrentData}
                  parantRender={() => {
                    handleChange(row?.[column?.uniqueName]);
                  }}
                  config={config}
                  sx={{
                    maxWidth: "200px",
                  }}
                />
              );
            })}
          </Box>
        )}
        {!!column?.addNew ? (
          <Button variant="outlined"> Add New </Button>
        ) : null}
      </Box>
    );
  } else if (column?.type === "navigation") {
    const navigateUrl = () => {
      const helperUrlObj =
        navLink !== false && !!navLink?.[column?.uniqueName] !== false
          ? navLink[column?.uniqueName](passCurrentData)
          : {};
      const generatedUrl = generateURL(column?.url, helperUrlObj);
      navigate(generatedUrl, { replace: true });
    };

    return <Button onClick={navigateUrl}>Link</Button>;
  } else if (column?.type === "chip") {
    let chipData = false;

    chip !== false && !!chip?.[column?.uniqueName] !== false
      ? (chipData = chip[column?.uniqueName](passCurrentData))
      : chipData !== false;

    const handleClick = () => {
      chipData?.onClick && chipData?.onClick(passCurrentData);
    };

    return (
      <CustomizeChip
        label={chipData?.label ?? "Chip"}
        size={chipData?.size ?? "medium"}
        variant={chipData?.variant ?? "filled"}
        color={chipData?.color ?? "success"}
        onClick={column?.navigateUrl ? handleClick : null}
      />
    );
  } else if (column?.type === "text") {
    return (
      <Box
        sx={{
          ...commonStyle,
        }}
      >
        <CustomTextInput
          label={`Enter ${column?.name}`}
          name={column.uniqueName}
          value={value}
          onChange={(e) => {
            handleChange(e?.target?.value);
          }}
          error={error}
          helperText={errorMsg}
          isLock={isLock || isDisable}
          isReadOnly={!!column?.isReadOnly}
        />
      </Box>
    );
  } else if (column?.type === "number") {
    let defaultValueAtFirst = value; // Start with current value

    // Compact initial default setting (inline, like nested table)
    if (
      !column?.MinMaxAlert &&
      (value === "" ||
        (typeof value === "string" && value.length === 0) ||
        Number(value) < column?.minValue) &&
      !!column?.minValue &&
      column?.minValue !== 0
    ) {
      defaultValueAtFirst = column?.minValue;
      handleChange(column?.minValue, null, true); // Update row directly
    }

    return (
      <CustomNumberInput
        value={defaultValueAtFirst}
        onChange={(e) => {
          handleChange(e?.target?.value);
        }}
        error={error}
        helperText={errorMsg}
        isLock={isLock || isDisable}
        isReadOnly={!!column?.isReadOnly}
        minValue={column?.minValue}
        maxValue={column?.maxValue}
        MinMaxAlert={column?.MinMaxAlert}
      />
    );
  } else if (column?.type === "dropdown") {
    return (
      <Box
        sx={{
          ...commonStyle,
        }}
      >
        <CustomDropdown
          label={column.name}
          name={column.uniqueName}
          value={value}
          onChange={(value) => {
            handleChange(value);
          }}
          options={
            myRowByOptions.length > 0 ? myRowByOptions : column?.options ?? []
          }
          multiple={column?.multiple}
          error={error}
          helperText={errorMsg}
          isLock={isLock || isDisable}
          isReadOnly={!!column?.isReadOnly}
          renderOptionKey={
            column?.renderOptionValue ? column?.renderOptionValue : false
          }
          inValidValues={column?.inValidValues || []}
        />
      </Box>
    );
  } else if (column?.type === "dynamicDropdown") {
    return (
      <Box
        sx={{
          ...commonStyle,
        }}
      >
        <CustomAutocomplete
          label={column.name}
          name={column.uniqueName}
          type={column.groupdBy}
          value={value}
          onChange={(value, changeMethod) => {
            handleChange(value, changeMethod);
          }}
          options={
            myRowByOptions.length > 0 ? myRowByOptions : column?.options ?? []
          }
          multiple={column?.multiple}
          freeSolo={column?.freeSolo ?? true}
          error={error}
          helperText={errorMsg}
          isLock={isLock || isDisable}
          isReadOnly={!!column?.isReadOnly}
          renderOptionKey={
            column?.renderOptionValue ? column?.renderOptionValue : false
          }
          selectOne={column?.selectOne ?? false}
        />
      </Box>
    );
  } else if (column?.type === "textarea") {
    return (
      <Box
        sx={{
          ...commonStyle,
        }}
      >
        <CustomTextarea
          label={`Enter ${column?.name}`}
          name={column.uniqueName}
          value={value}
          onChange={(e) => {
            handleChange(e?.target?.value);
          }}
          error={error}
          helperText={errorMsg}
          isLock={isLock}
          isReadOnly={!!column?.isReadOnly}
        />
      </Box>
    );
  } else if (["date", "datetime"]?.includes(column?.type)) {
    if (!value && (!moment(value).isValid() || [undefined, null]?.includes(value))) {
      row[column?.uniqueName] = moment().toISOString();
      render();
    }

    return (
      <Box
        sx={{
          ...commonStyle,
        }}
      >
        <CustomDatePicker
          label={column.name}
          name={column.uniqueName}
          value={value}
          onChange={(e) => {
            handleChange(e);
          }}
          disablePast={column?.disablePast}
          error={error}
          helperText={errorMsg}
          isLock={isLock || isDisable}
          isReadOnly={!!column?.isReadOnly}
          dateTime={column?.type === "datetime"}
          minValue={column?.minValue}
          maxValue={column?.maxValue}
        />
      </Box>
    );
  } else if (column?.type === "esign") {
    const beforeOpen = (state) => {
      const before = onESign?.before || {};
      const checkValidation = before?.checkValidation ?? true;
      const handler = before?.handler ?? false;
      if (onESign !== false) {
        if (checkValidation && !helperUtils("checkValidation", row, rowIndex)) {
          return;
        }
        if (handler) {
          handler(state, passCurrentData);
        } else {
          state();
        }
      } else {
        state();
      }
    };
    const handleSubmit = (submitStatus) => {
      const eSignData = helperUtils("esignData");
      if (submitStatus) {
        if (multipleESign !== false) {
          const { format, start } = multipleESign;
          const isLastStep =
            row?.currentESignStep === format?.[format.length - 1];
          if (isLastStep) {
            delete row?.currentESignStep;
            row.submitted = true;
            row.isLock = true;
          } else {
            const nextIndex = format?.indexOf(row?.currentESignStep) + 1;
            row.currentESignStep = format[nextIndex];
          }
        }
        handleChange(eSignData);
        showToast("Submit successfully", true);
        onESign?.after?.(submitStatus, eSignData, passCurrentData);
      } else {
        onESign?.after?.(submitStatus, null, passCurrentData);
        showToast("Submit failed", false);
      }

      renderRow();
    };

    if (!!value) {
      const { time = false, userData = {} } = value;
      const constFormate = getItem(Constants?.DATE_FORMATE);

      return (
        <Box
          sx={{
            py: "6px",
          }}
        >
          <Typography variant="h6" color="text.primary">
            {userData?.name ?? "N/A"}
          </Typography>
          <Typography variant="h6" color="text.primary">
            {userData?.designation ?? "N/A"}
          </Typography>
          <Typography variant="h6" color="text.primary">
            {isISODateString(time)
              ? moment(time).format(
                  !!constFormate ? constFormate : "DD/MM/YYYY hh:mm A"
                )
              : time ?? "N/A"}
          </Typography>
        </Box>
      );
    }

    return (
      <CustomESign
        open={esignOpen}
        setOpen={setEsignOpen}
        handleSubmit={handleSubmit}
        beforeOpen={beforeOpen}
        // disabled={isLock || isDisable}
        // disabled={
        //   isLock || isDisable || getEnableDisableEsign() || column?.isDisable
        // }
        disabled={
          isLock ||
          isDisable ||
          getEnableDisableEsign() ||
          (typeof column?.isDisable === "function"
            ? column.isDisable(row, rowIndex)
            : column?.isDisable)
        }
      />
    );
  } else if (column?.type === "time") {
    return (
      <>
        <CustomTime
          onChange={(e) => {
            handleChange(e?.target?.value);
          }}
          label={`Enter ${column?.name}`}
          name={column?.name}
          value={value}
          error={error}
          helperText={errorMsg}
          isLock={isLock || isDisable}
          isReadOnly={!!column?.isReadOnly}
        />
      </>
    );
  } else if (column?.type === "file") {
    return (
      <Box
        sx={{
          ...commonStyle,
        }}
      >
        <CustomFileInput
          label={column.name}
          name={column.uniqueName}
          value={value}
          onChange={(e) => {
            handleChange(e?.target?.value);
          }}
          multiple={column?.multiple}
          error={error}
          helperText={errorMsg}
          isLock={isLock}
          isImageinLink={isImageinLink}
        />
      </Box>
    );
  } else if (column?.type === "address") {
    if (hasEmptyValue(value)) {
      return (
        <Box
          sx={{
            ...commonStyle,
          }}
        >
          <CustomAddress
            action={"add"}
            label={column.name}
            name={column.uniqueName}
            value={value}
            onChange={(value) => {
              handleChange(value);
            }}
            error={error}
            helperText={errorMsg}
            isLock={isLock || isDisable}
            isReadOnly={!!column?.isReadOnly}
          />
        </Box>
      );
    } else {
      return (
        <Box
          sx={{
            ...commonStyle,
            gap: "20px",
          }}
        >
          <Typography>{value?.finalAddress}</Typography>
          <CustomAddress
            action={!!value?.finalAddress ? "edit" : "add"}
            label={column.name}
            name={column.uniqueName}
            value={value ?? {}}
            onChange={(value) => {
              handleChange(value);
            }}
            error={error}
            helperText={errorMsg}
            isLock={isLock || isDisable}
            isReadOnly={!!column?.isReadOnly}
          />
        </Box>
      );
    }
  } else if (column?.type === "checkbox") {
    return (
      <CustomCheckbox
        label={`Enter ${column?.name}`}
        name={column.uniqueName}
        checked={value}
        onChange={(newValue) => {
          handleChange(newValue);
        }}
        isReadOnly={!!column?.isReadOnly}
        isLock={isLock || isDisable}
        error={error}
        helperText={errorMsg}
      />
    );
  } else {
    return (
      <Box
        sx={{
          ...commonStyle,
        }}
      >
        <CustomTextInput
          label={`Enter ${column?.name}`}
          name={column.uniqueName}
          value={value}
          onChange={(e) => {
            handleChange(e?.target?.value);
          }}
          error={error}
          helperText={errorMsg}
          isLock={isLock || isDisable}
        />
      </Box>
    );
  }
};

export default RowCell;
